import { defaultCacheableSingleton } from '@/lib/cacheable';
import { JobBlockDisplayType, Page, RowrowComponentsUnion } from '@/lib/types';

import lookerQueryClient from '@/pages/api/api-clients/looker-query-api-client';
import { endOfDay } from '@/utils/date-utils';
import { getPageComponents } from '@/utils/page-static-utils';

type THighPayingJob = {
  id: string;
  title: string;
  code: string;
  city: string;
  state: string;
  discipline: string;
  specialty: string;
  weekly_pay: number;
  shift: string;
};

export type HighPayingJobsResponse = THighPayingJob[];

const getHighPayingJobs = async () => {
  return defaultCacheableSingleton.remember(
    'looker:highPayingJobs',
    async () => {
      return lookerQueryClient
        .get('api/v1/looker/high-paying-jobs')
        .then((response) => response.data.data)
        .then((data: THighPayingJob[]) => data.filter((job) => job.shift));
    },
    endOfDay(new Date())
  );
};

const get = async (page: Page): Promise<HighPayingJobsResponse> => {
  const hasHighPayingJobsCheck = (rc: RowrowComponentsUnion) =>
    rc.__typename === 'JobBlock' &&
    rc.jobBlockDisplayType === JobBlockDisplayType.HighPayingJobs;

  const hasHighPayingJobs =
    getPageComponents(page, hasHighPayingJobsCheck).length > 0;

  return hasHighPayingJobs ? await getHighPayingJobs() : [];
};

const HighPayingJobsService = {
  get,
};

export default HighPayingJobsService;
